import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { Card, CardTitle } from 'components/Card';
import Message from 'components/Message';
import { venuePropTypes } from 'constants/propTypes';

import './VenuePagesSection.scss';

const messages = defineMessages({
  venuePagesLabel: {
    id: 'settings.venue-pages-section.venues-list-label',
    defaultMessage: 'Locations on ClassPass',
  },
});

export const VenuePagesSection = ({ venues }) => (
  <Card>
    <Message as={CardTitle} message={messages.venuePagesLabel} />

    <ul className="venue-pages-section">
      {venues.map(({ venueId, venueAliasUrl, venueName, venueSubtitle }) => (
        <li key={venueId}>
          <a
            className="venue-pages-section__link"
            key={venueId}
            href={venueAliasUrl}
            rel="noopener noreferrer"
            target="_blank">
            {venueName} {venueSubtitle && `(${venueSubtitle})`}
          </a>
        </li>
      ))}
    </ul>
  </Card>
);

VenuePagesSection.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  venues: PropTypes.arrayOf(PropTypes.shape(venuePropTypes)),
};

export default VenuePagesSection;
